/**
 * Application configuration
 * Client-side safe configuration values
 */

export const config = {
  company: {
    name: 'Falcon',
    productName: 'Falcon',
    address: {
      street: '123 Business Ave, Suite 456',
      city: 'London',
      state: 'London',
      zipCode: 'SW1P 3AG',
      country: 'United Kingdom',
    },
    email: {
      support: 'support@usefalcon.ai',
      legal: 'legal@usefalcon.ai',
      privacy: 'privacy@usefalcon.ai',
    },
  },
} as const;

/**
 * Helper functions to get company information (client-safe)
 */
export const getCompanyName = () => config.company.name;

export const getProductName = () => config.company.productName;

export const getCompanyAddress = () => config.company.address;

export const getCompanyAddressString = () => {
  const addr = config.company.address;
  return `${addr.street}, ${addr.city}, ${addr.state} ${addr.zipCode}`;
};

export const getCompanyFullAddress = () => {
  const addr = config.company.address;
  return `${config.company.name}, ${addr.street}, ${addr.city}, ${addr.state} ${addr.zipCode}`;
};

export const getCompanyEmails = () => config.company.email;

export const FIND_PEOPLE_ENABLED =
  import.meta.env.VITE_ENABLE_FIND_PEOPLE === 'true' || import.meta.env.DEV;

